import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { initializeSetup } from '@/setup';

/* ------ Load Dynmic Files -> main.css ------ */
initializeSetup().then(() => {
    import('@assets/css/main.css');
});

import App from '@/App.vue';
import router from '@/router';
import VueCookies from 'vue-cookies';

import { plgDevice } from '@app/base-package';
import { plgI18n } from '@app/base-package';
import { plgSdk } from '@app/base-package';
import { registerLayouts } from '@app/base-package';
import type { ModuleNamespace } from '@coreInterfaces/interface';

/* ------ Localization Files ------ */
import cn from '@locales/cn.json';
import en from '@locales/en.json';

/* ------ Datetime ------ */
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

/* ------ Vue App Generation ------ */
const app = createApp(App);
const i18n = plgI18n({
    cn,
    en
});

app.use(createPinia());
app.use(router);
app.use(VueCookies, { expires: '1d' });
app.use(i18n);
app.use(plgDevice);
app.use(plgSdk);

app.component('VueDatePicker', VueDatePicker);

/* ------ Register Auto Focus ------ */
app.directive('focus', {
    mounted(el) {
        el.focus();
    }
});

/* ------ Register Layouts ------ */
const layouts = import.meta.glob('./layouts/*.vue', { eager: true }) as Record<string, ModuleNamespace>;
registerLayouts(app, layouts);

app.mount('#app');
